//import RealSplitLaunches from "./RealSplitLaunches";
import {
    Link
    , useNavigate
} from 'react-router-dom';

import loreHeroImageUrl from '../../../assets/images/Screenshots/RealSplit-LORE-LA-Hero-Section_870x472.jpg';

const RealSplitLaunches = () => {

    //const [about, setAbout] = useState(null);
    const navigate = useNavigate()
    // useEffect(() => {
    //   axiosInstance.get('/webcontent?key=about_us').then((res) => {
    //     setAbout(res?.data?.result[0]);
    //   }).catch((err) => {
    //     PopUpAlert("Alert", err?.data?.response?.error ? err?.data?.response?.error : err.message, "error")
    //   })
    // }, []);
    const redirectNft = () => {
        navigate('/search/all')
    }

    function openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    return (
      
        <>

        {/*
        <h1
            style = {{
                //color: 'var(--color-gray-700)'
                color: 'white'
                //, textAlign: 'center'
                , fontFamily: 'Baskervville'
            }}>
            RealSplit™ Launches
        </h1>
        */}

        <div
            className="about-section about-how-it-works"
            style = {{
                marginTop: '0px'
                , paddingTop: '30px'
                , paddingBottom: '30px'
            }}
            >

            {/*
            <div
                className = 'about-section-circle-wrapper'
                //style = {{
                //    textAlign: 'center'
                //    , margin: 'auto'
                //    , marginTop: '-65px'
                //}}
                >
                <div className = 'about-section-circle'>
                    <img
                        className = 'svg'
                        //src = 'images/icons/work-started-icon.svg'
                        //src = 'https://img.icons8.com/sf-black-filled/64/FFFFFF/administrative-tools.png'
                        src = 'images/icons/factory-svgrepo-com.svg'
                        />
                </div>
            </div>
            */}

            <div
                //style = {{ borderLeft: 'var(--color-theme-primary) 2px solid' }}
                className = "about-content"
                >

                {/*
                <div
                    //style = {{ borderLeft: 'var(--color-theme-primary) 5px solid', borderTopLeftRadius: '5px' }}
                    >
                    <Link
                        to = '/news/RealSplitLaunches'
                        >
                        RealSplit™ Launches Fractional Real Estate Platform with Three Blue-Chip Properties
                    </Link>
                </div>
                */}

                <h2
                    style = {{
                        paddingBottom: '20px'
                        //paddingLeft: '100px'
                    }}
                    >RealSplit™ Launches Fractional Real Estate Platform with Three Blue-Chip Properties</h2>

                {/*
                <Link
                    to = '/news/RealSplitLaunches'
                    to = 'https://www.pr.com/press-release/938010'
                    >
                    Sugar Land, TX, May 07, 2025 --(PR.com)-- RealSplit Technology Group. RealSplit™ Launches Fractional Real Estate Platform with Three Blue-Chip Properties
                </Link>
                */}

                <h3
                    style = {{
                        paddingTop: '10px'
                        , paddingBottom: '30px'
                        //paddingLeft: '100px'
                    }}
                    >RealSplit offers fractional ownership in blue-chip commercial properties. They enable investors to resell their ownership in a property on a secondary marketplace that's fully compliant with FINRA/SEC.</h3>

                <p
                    style = {{ padding: '0px' }}>
                    {/*
                    */}
                    <img
                        //src = '/images/Screenshots/RealSplit-LORE-LA-Hero-Section_670x362.jpg'
                        src = { loreHeroImageUrl }
                        style = {{ width: '100%' }}
                        />
                </p>

                <p
                    style = {{
                          paddingTop: '30px'
                        , paddingBottom: '10px'
                        //, paddingLeft: '100px'
                    }}
                    >
                    <a
                        style = {{
                            //paddingLeft: '100px'
                            cursor: 'pointer'
                        }}
                        //onClick = { 'https://www.pr.com/press-release/938010'
                        onClick = { () => openInNewTab('https://www.pr.com/press-release/938010') }
                    >Sugar Land, TX, May 07, 2025 --(PR.com)-- RealSplit Technology Group. RealSplit™ Launches Fractional Real Estate Platform with Three Blue-Chip Properties</a>
                </p>

                <p>
                    <strong>RealSplitSugar Land, TX, May 07, 2025</strong> --(PR.com)-- RealSplit™, a proprietary software platform that enables real estate investment through fractional ownership is actively signing up accredited investors for fractionalized CRE offerings.
                </p>

                <p>
                    RealSplit™ makes it easy for nearly anyone to own a piece of income-generating real estate. At launch, investors will be able to explore and invest in these three blue-chip properties:
                </p>

                <p>
                    <strong>LORE LA</strong> –Mixed-Use Property in Inglewood CA, walking distance to all 3 stadiums. https://realsplit.net/property/LORE-LA/listing/1
                </p>

                <p>
                    <strong>Alumina</strong> – Beachfront Hotel & Medical Spa located in Tulum Mexico.
                    https://realsplit.net/property/Alumina-Tulum/listing/9
                </p>

                <p>
                    <strong>QuikWash #7</strong> – Cash Flow Car Wash! Own the 7th new location with the other six franchises earning 40% + ROI.
                    https://realsplit.net/property/QuikWash-Bellflower/listing/8
                </p>

                <p>
                    Each of these properties represents the types of properties that have been hand-selected by RealSplit’s team for launch.
                </p>

                <p>
                    “Our mission is to lower the barrier to real estate ownership,” said Brian Massie, Co-Founder/CEO at RealSplit™. “We only offer properties that we have vetted and are worth putting our own money into. With LORE, Alumina, and QuikWash, we’re showcasing the kind of diverse, income-producing assets that RealSplit is offering to our investor community.”
                </p>

                <p>
                    Investors can sign up now at https://realsplit.net to be notified as soon as the platform goes live.
                </p>

                <p>
                    Media Contact:
                    <br/>Please email <a
                        onClick = { () => openInNewTab('mailto:info@realsplit.net') }
                        >info@realsplit.net</a>.
                </p>

                <p>
                    Contact
                    <br/>RealSplit Technology Group
                    <br/>DJ Sloan
                    <br/>346-537-6944
                    <br/><a
                        onClick = { () => openInNewTab('https://realsplit.net/') }
                        >https://realsplit.net/</a>
                </p>

            </div>
        </div>

        </>
        
    );
};

export default RealSplitLaunches;
